module.exports = __webpack_public_path__ + "static/media/painter.a5b6f845.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/ProductCatalog/Components/CatalogCheckbox/painter.svg
// module id = 672
// module chunks = 1